export default "__VITE_ASSET__R9R$Wj5e__"